// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"e1cfe165","443":"cebc98ea","627":"e1cfe165"}[chunkId] + ".chunk.css";
};